import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getHotLine = async (params: object) => {
  return await GET({ url: Api.getHotLine, params, showError: false })
}
export const queryMobileInfo = async (params: object) => {
  return await GET({ url: Api.queryMobileInfo, params, showError: false })
}
